import { HIDE_PARTNER_TUTORIALS_KEY } from '@/constants/videoTutorials';
import { log } from '@/utils/functions/logger/logger';

const readPartnerTutorialsPreference = (): boolean => {
  try {
    return globalThis.localStorage.getItem(HIDE_PARTNER_TUTORIALS_KEY) === 'true';
  } catch (error) {
    log.warn('[partnerTutorialsPreference] Lecture impossible', error);
    return false;
  }
};

export default readPartnerTutorialsPreference;
